import { FC, ReactNode } from "react";

const Card: FC<{
  children: ReactNode;
  header: ReactNode;
  footer?: ReactNode;
}> = ({ header, children, footer }) => (
  <div className="card">
    <div className="card-header">{header}</div>
    <div className="card-content">{children}</div>
    {footer ? <div className="card-footer">{footer}</div> : null}
  </div>
);

export default Card;
